var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.badgeData
    ? _c(
        "div",
        { staticClass: "d-flex justify-content-center mt-2 mt-lg-n2" },
        [
          _vm.badgeData.url
            ? [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.badgeData.url,
                      title: _vm.badgeData.title,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                    on: { click: _vm.openInfo },
                  },
                  [
                    _c("img", {
                      staticStyle: { "max-height": "100px" },
                      attrs: {
                        src: _vm.badgeData.imgUrl,
                        alt: _vm.badgeData.title,
                      },
                    }),
                  ]
                ),
              ]
            : [
                _c("img", {
                  staticStyle: { "max-height": "100px" },
                  attrs: {
                    src: _vm.badgeData.imgUrl,
                    alt: _vm.badgeData.title,
                    title: _vm.badgeData.title,
                  },
                }),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }